/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.4.0
 * @since 1.0.0
 */


import { createAction } from '../app/createAction';
import { HIDE_LOADER, SET_TEXT_LOADER, SHOW_LOADER } from './loaderConstants';
import { IHideLoader, ISetTextLoader, IShowLoader } from './loaderTypes';

/**
 * @description action for showing loader component
 * @function showLoader
 * @return {IShowLoader} action
 */
export const showLoader = (): IShowLoader =>
    createAction(SHOW_LOADER);

/**
 * @description action for hiding loader component
 * @function hideLoader
 * @return {IHideLoader} action
 */
export const hideLoader = (): IHideLoader =>
    createAction(HIDE_LOADER);

export const setTextLoader = (payload: string): ISetTextLoader =>
    createAction(SET_TEXT_LOADER, payload);
